/**
 * Konfigurationsobjekt für GenericSlider
 */
export class SliderConfig {
  constructor(options = {}) {
    this.listSelector = options.listSelector || '.slider-list';
    this.itemSelector = options.itemSelector || '.slider-item';
    this.controlsSelector = options.controlsSelector || '.navigation-controls';
    this.prevButtonSelector = options.prevButtonSelector || '.prev';
    this.nextButtonSelector = options.nextButtonSelector || '.next';
    this.scrollMultiplier = options.scrollMultiplier ?? 2;
    this.visibilityThreshold = options.visibilityThreshold || [0.9, 1.0];
    this.visibilityRatio = options.visibilityRatio || 0.9;
    this.enableResize = options.enableResize !== false;
  }
}
